import { Link } from "react-router-dom";
import {
  MapPin,
  Phone,
  Clock,
  Instagram,
  MessageCircle,
} from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY, WHATSAPP_URL, MAPS_URL } from "@/lib/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#080808]">
    <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/assets/logo-emblem.png"
              alt="Syed's Pro Drive Inspection logo"
              className="h-10 w-10 rounded-xl border border-gold/30 object-cover"
            />
            <span className="leading-none">
              <span className="block font-heading text-sm font-extrabold tracking-tight text-white">
                Syed's Pro Drive
              </span>
              <span className="block text-[10px] font-bold uppercase tracking-[0.28em] text-gold">
                Inspection
              </span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/45">
            Professional pre-owned &amp; new car inspection services. Buy your
            next car with complete confidence.
          </p>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-white/40">
            Contact
          </h4>
          <ul className="mt-5 space-y-3.5 text-sm">
            <li>
              <a
                data-testid="footer-location-link"
                href={MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/70 transition-colors duration-300 hover:text-gold"
              >
                <MapPin className="h-4 w-4 text-gold" /> Hyderabad, India
              </a>
            </li>
            <li>
              <a
                data-testid="footer-phone-link"
                href={PHONE_TEL}
                className="flex items-center gap-3 text-white/70 transition-colors duration-300 hover:text-gold"
              >
                <Phone className="h-4 w-4 text-gold" /> {PHONE_DISPLAY}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-white/40">
            Business Hours
          </h4>
          <div className="mt-5 inline-flex items-center gap-3 rounded-full border border-gold/30 bg-gold/10 px-4 py-2">
            <Clock className="h-4 w-4 text-gold" />
            <span
              data-testid="footer-hours-badge"
              className="text-sm font-bold text-gold"
            >
              Open 24 Hours
            </span>
          </div>
          <p className="mt-4 text-sm text-white/45">
            Same-day booking available across Hyderabad.
          </p>
        </div>

        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.25em] text-white/40">
            Follow Us
          </h4>
          <div className="mt-5 flex gap-3">
            <a
              data-testid="footer-instagram-link"
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-white/70 transition-[border-color,color,transform] duration-300 hover:-translate-y-1 hover:border-gold/50 hover:text-gold"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              data-testid="footer-whatsapp-link"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-white/70 transition-[border-color,color,transform] duration-300 hover:-translate-y-1 hover:border-[#25D366]/60 hover:text-[#25D366]"
            >
              <MessageCircle className="h-5 w-5" />
            </a>
            <a
              data-testid="footer-maps-link"
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Google Maps"
              className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-white/70 transition-[border-color,color,transform] duration-300 hover:-translate-y-1 hover:border-gold/50 hover:text-gold"
            >
              <MapPin className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8">
        <p className="text-xs text-white/35">
          © 2026 Syed's Pro Drive Inspection. All rights reserved.
        </p>
        <Link
          data-testid="footer-admin-link"
          to="/admin"
          className="text-xs font-semibold text-white/35 transition-colors duration-300 hover:text-gold"
        >
          Admin Login
        </Link>
      </div>
    </div>
  </footer>
);
